<app-nav-bar *ngIf="(layout.config$ | async)?.showNavbar"></app-nav-bar>

<div class="content" [class.hide-nav]="!(layout.config$ | async)?.showNavbar">
  <div class="page mat-app-background">
    <router-outlet></router-outlet>
  </div>
  <app-footer *ngIf="(layout.config$ | async)?.showFooter"></app-footer>
</div>
